import { render, staticRenderFns } from "./DashboardLogin.vue?vue&type=template&id=52dabb32&"
import script from "./DashboardLogin.vue?vue&type=script&lang=js&"
export * from "./DashboardLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports